"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBath = function IconBath(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M40.435 5.96a5.04 5.04 0 0 0-3.54-1.46c-.76 0-1.52.18-2.21.51a5.1 5.1 0 0 0-1.573 1.223 5 5 0 0 0-6.558.439L25.136 8.09l7.774 7.774 1.418-1.418a5 5 0 0 0 .216-6.831c.278-.32.664-.626 1.031-.805.41-.2.86-.31 1.32-.31 1.26 0 2.12.88 2.12.88.56.56.88 1.32.88 2.12V24h-2.946a2.5 2.5 0 0 0-2.449-2h-5a2.5 2.5 0 0 0-2.45 2H4v7a13 13 0 0 0 13 13h14a13 13 0 0 0 13-13v-7h-2.105V9.5c0-1.33-.52-2.6-1.46-3.54M28 24.5V35h8V24.5a1.5 1.5 0 0 0-1.5-1.5h-5a1.5 1.5 0 0 0-1.5 1.5M27 26H6v5a11 11 0 0 0 11 11h14a11 11 0 0 0 11-11v-5h-5v10H27zm-11.094-5.354 9.6-9.6.708.708-9.6 9.6zm8 0 5.6-5.6.708.708-5.6 5.6zm3.6-7.6-7.6 7.6.708.708 7.6-7.6zm.46-4.958-.002.002 4.946 4.946.002-.002a3 3 0 0 0 0-4.237l-.708-.709a3 3 0 0 0-4.238 0",
    clipRule: "evenodd"
  })));
};

export { IconBath, IconBath as default };
